<div class="container-fluid" *ngIf="permissions.canRead(permissions.ComponentID.EngineeringConfig)">
  <form #engConfigForm="ngForm">
    <div class="row top10 no-gutters">
      <div class="col-xs-12 col-lg-4 vcenter">
        <h3>Engineering Config</h3>
      </div>
      <div class="col-xs-12 col-lg-8 vcenter-right">
        <div class="btn-group" role="group" aria-label="...">
          <aims-common-button
            title="Save"
            [disabled]="(!engConfigForm.valid || engConfigForm.pristine || !permissions.canUpdate(permissions.ComponentID.EngineeringConfig))"
            (click)="saveClick()">
            <mat-icon color="primary">save</mat-icon>
          </aims-common-button>
        </div>
      </div>
    </div>
    <hr style="margin-top:2px;margin-bottom:2px" />
    <aims-form cols="4">
      <aims-fc>
        <aims-numeric [numericType]="AIMS_NUMERIC_TYPES.PERCENT"
          #aimsControl="ngModel"
          class="fullWidth"
          name="Overhead % Default"
          [(ngModel)]="defaultOverhead"
          [min]="0" [max]="1"
          [spinners]="true">
        </aims-numeric>
      </aims-fc>
    </aims-form>
    <aims-form cols="4">
      <aims-fc>
        <aims-numeric [numericType]="AIMS_NUMERIC_TYPES.PERCENT"
          #aimsControl="ngModel"
          class="fullWidth"
          name="Payroll Tax % Default"
          [(ngModel)]="defaultPayrollTax"
          [min]="0" [max]="1"
          [spinners]="true">
        </aims-numeric>
      </aims-fc>
    </aims-form>
    <aims-form cols="4">
      <aims-fc>
        <aims-numeric [numericType]="AIMS_NUMERIC_TYPES.PERCENT"
          #aimsControl="ngModel"
          class="fullWidth"
          name="Non Prod % Default"
          [(ngModel)]="defaultNonProd"
          [min]="0" [max]="1" >
        </aims-numeric>
      </aims-fc>
    </aims-form>
  </form>
  <aims-spinner [spinnerText]="spinnerText" [showSpinner]="showSpinner"></aims-spinner>
</div>
